export const editFacture = async (id_facture, invoiceData) => {

    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    
    const response = await fetch(`${apiUrl}/api/facture/${id_facture}`, { 
        method: 'PUT', 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(invoiceData), 
    });

    if (!response.ok) {
        throw new Error('Failed to update invoice');
    }

    return await response.json();
};
